import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { debug } from "util";
import { render } from "react-dom";
//import style from './Geo.module.css';
import { Textfit } from 'react-textfit';

import LiftSign from "../assets/Measurements/Images/LiftSign.png"
import LineTo from 'react-lineto';

function fitImage(src) {
  var image = new Image();
  image.src = src;
  var height = image.height;
  var width = image.width;
  var scale;

  var color = "0";

  if (width > height) { // Image is wider than it's high
    scale = 90 / height;
  }
  else { // Image is higher than it's wide
    scale = 90 / width;
  }

  image.width = width * scale;
  image.height = height * scale;

  document.getElementById('info').innerHTML = width + 'x' + height + ' => ' + image.width + 'x' + image.height;

  document.getElementById('container').style.backgroundImage = 'url(' + image.src + ')';
  document.getElementById('container').style.backgroundSize = image.width + 'px ' + image.height + 'px';
}

export default function MultipleChoice({ currentQuestion, ...props }) {
  //filter button list
  let buttonList = [];
  if (currentQuestion.answers != undefined) {
    for (let i = 0; i < currentQuestion.answers.length; i++) {
      if (currentQuestion.answers[i].name)
        console.log("push")
    }
  }

  if (currentQuestion.image != "" && currentQuestion.image != undefined) {
    var currImage = currentQuestion.image;
    var correctAnswerName;
    //gets correct answer name for testing
    for (let i = 0; i < currentQuestion.answers.length; i++) {
      if (currentQuestion.answers[i].correct == true)
        correctAnswerName = currentQuestion.answers[i].value;
    }
    //check if image is certain images then change it
    if (currentQuestion.image == "grid2squares.jpg") {
      if (correctAnswerName == "4,3")
        currImage = "grid2squares43.jpg"
      else if (correctAnswerName == "2,5") {
        currImage = "grid2squares25.jpg";
      }
      else if (correctAnswerName == "5,2") {
        currImage = "grid2squares52.jpg";
      }
      else if (correctAnswerName == "1,5") {
        currImage = "grid2squares15.jpg";
      }
      else if (correctAnswerName == "5,5") {
        currImage = "grid2squares55.jpg";
      }
      else if (correctAnswerName == "5,4") {
        currImage = "grid2squares54.jpg";
      }
    }
    if (currentQuestion.image == "firstquadgrid.jpg") {
      if (correctAnswerName == "2,3")
        currImage = "firstquadgrid23.jpg"
      else if (correctAnswerName == "5,1") {
        currImage = "firstquadgrid51.jpg";
      }
      else if (correctAnswerName == "1,5") {
        currImage = "firstquadgrid15.jpg";
      }
      else if (correctAnswerName == "2,5") {
        currImage = "firstquadgrid25.jpg";
      }
      else if (correctAnswerName == "4,2") {
        currImage = "firstquadgrid42.jpg";
      }
      else if (correctAnswerName == "1,3") {
        currImage = "firstquadgrid13.jpg";
      }
      else if (correctAnswerName == "5,5") {
        currImage = "firstquadgrid55.jpg";
      }
      else if (correctAnswerName == "5,1") {
        currImage = "firstquadgrid51.jpg";
      }
      else if (correctAnswerName == "3,5") {
        currImage = "firstquadgrid35.jpg";
      }
      else if (correctAnswerName == "5,2") {
        currImage = "firstquadgrid52.jpg";
      }
      else if (correctAnswerName == "4,3") {
        currImage = "firstquadgrid43.jpg";
      }
      else if (correctAnswerName == "2,5") {
        currImage = "firstquadgrid25.jpg";
      }
      else if (correctAnswerName == "5,4") {
        currImage = "firstquadgrid54.jpg";
      }

    }
    if (currentQuestion.image == "Gridsquaremirror.jpg") {
      if (correctAnswerName == "(1,1)(2,1)(2,2)(1,2)") {
        currImage = "Gridsquaremirror11.jpg"
      }
      else if (correctAnswerName == "(2,2)(3,2)(3,3)(2,3)") {
        currImage = "Gridsquaremirror22.jpg"

      }
      else if (correctAnswerName == "(2,3)(3,3)(3,4)(2,4)") {
        currImage = "Gridsquaremirror23.jpg"
      }

      else if (correctAnswerName == "(2,0)(3,0)(3,1)(2,1)") {
        currImage = "Gridsquaremirror20.jpg"
      }

    }
    if (currentQuestion.image == "Gridsquare.jpg") {
      if (correctAnswerName == "(4,2)(5,2)(5,3)(4,3)") {
        currImage = "Gridsquare42.jpg"
      }
      else if (correctAnswerName == "(2,2)(3,2)(3,3)(2,3)") {
        currImage = "Gridsquare22.jpg"
      }
      else if (correctAnswerName == "(5,0)(6,0)(6,1)(5,1)") {
        currImage = "Gridsquare50.jpg"
      }

    }
    if (currentQuestion.image == "fullquadgrid.jpg") {
      if (correctAnswerName == "(4,3)") {
        currImage = "fullquadgrid43"
      }
      else if (correctAnswerName == "(2,-2)") {
        currImage = "fullquadgrid2-2"
      }
      else if (correctAnswerName == "(-4,4)") {
        currImage = "fullquadgrid-44"
      }
      else if (correctAnswerName == "(-4,-2)") {
        currImage = "fullquadgrid-4-2"
      }
      else if (correctAnswerName == "(-3,4)") {
        currImage = "fullquadgrid-34"
      }
      else if (correctAnswerName == "(-4,2)") {
        currImage = "fullquadgrid-42"
      }
      else if (correctAnswerName == "(-3,-3)") {
        currImage = "fullquadgrid-3-3"
      }
      else if (correctAnswerName == "(3,3)") {
        currImage = "fullquadgrid33"
      }
      else if (correctAnswerName == "(2,4)") {
        currImage = "fullquadgrid24"
      }
      else if (correctAnswerName == "(-2,4)") {
        currImage = "fullquadgrid-24"
      }
      else if (correctAnswerName == "(-2,-4)") {
        currImage = "fullquadgrid-2-4"
      }
      else if (correctAnswerName == "(1,1)") {
        currImage = "fullquadgrid11"
      }
      else if (correctAnswerName == "(-1,-1)") {
        currImage = "fullquadgrid-1-1"
      }
      else if (correctAnswerName == "(-1,-1)") {
        currImage = "fullquadgrid-1-1"
      }
      else if (correctAnswerName == "(-1,1)") {
        currImage = "fullquadgrid-11"
      }
      else if (correctAnswerName == "(-4,-1)") {
        currImage = "fullquadgrid-4-1"
      }
      else if (correctAnswerName == "(3,1)") {
        currImage = "fullquadgrid31"
      }
      else if (correctAnswerName == "(3,-2)") {
        currImage = "fullquadgrid3-2"
      }
      else if (correctAnswerName == "(-4,-4)") {
        currImage = "fullquadgrid-4-4"
      }
      else if (correctAnswerName == "(4,4)") {
        currImage = "fullquadgrid44"
      }
      else if (correctAnswerName == "(4,-4)") {
        currImage = "fullquadgrid4-4"
      }
      else if (correctAnswerName == "(-2,-2)") {
        currImage = "fullquadgrid-2-2"
      }
      else if (correctAnswerName == "(4,-1)") {
        currImage = "fullquadgrid4-1"
      }
      else {
        currImage = "fullquadgrid";
      }
      currImage += ".jpg";
    }
    if (currentQuestion.image == "rectlongside.jpg") {
      if (correctAnswerName == "20") {
        currImage = "rectlongside20.jpg";
      }
      else if (correctAnswerName == "45") {
        currImage = "rectlongside45.jpg";
      }
      else if (correctAnswerName == "150") {
        currImage = "rectlongside150.jpg";
      }
      else if (correctAnswerName == "270") {
        currImage = "rectlongside270.jpg";
      }
      else if (correctAnswerName == "8") {
        currImage = "rectlongside8.jpg";
      }
    }
    if (currentQuestion.image == "rectshortside.jpg") {
      if (correctAnswerName == "2") {
        currImage = "rectshortside2.jpg";
      }
      else if (correctAnswerName == "5") {
        currImage = "rectshortside5.jpg";
      }
      else if (correctAnswerName == "7") {
        currImage = "rectshortside7.jpg";
      }
      else if (correctAnswerName == "15") {
        currImage = "rectshortside15.jpg";
      }
      else if (correctAnswerName == "75") {
        currImage = "rectshortside75.jpg";
      }
    }

    var imagePath = currImage.replace(".jpg", ".png");
    var image = require('../assets/Statistics/Images/' + imagePath);
  }

  function FilteredAnswers() {
    console.log(currentQuestion.answers[0].answerImage);
    return currentQuestion.answers.filter(v => v.value !== "");
  }

  function Template({ html }) {
    return (
      <div dangerouslySetInnerHTML={{ __html: html }} />
    );
  }


  return (
    <>
      <Container>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <Question
            type="text"
            disabled
            value={
              currentQuestion.question !== undefined
                ? currentQuestion.question.replace("$", "?")
                : ""
            }
          ><Textfit mode="multi" max="50" style={{ height: "100%" }}><span>{<div dangerouslySetInnerHTML={{ __html: (currentQuestion.question) }} />}</span></Textfit></Question>
        </div>

        <div style={{ display: "flex", flexDirection: "row", alignSelf: "center" }}>
          {currentQuestion.image != "" && currentQuestion.questionHTML == "" ? (
            <img src={image}></img>
            /*<img src = {image} className ={style.geoImg} filter = {hue-rotate(60deg);}></img>*/
          ) : (
              <div></div>
            )}
          {currentQuestion.questionHTML != "" ? (
            //<div dangerouslySetInnerHTML={{__html: currentQuestion.questionHTML}}></div>
            //<div><img src={require("../assets/Measurements/Images/LiftSign.png")}></img></div>
            //<div innerHtml={currentQuestion.questionHTML}></div>
            <DynamicStyle>
              <div dangerouslySetInnerHTML={{__html: currentQuestion.questionHTML}}></div>
            </DynamicStyle>
          ) :
            (
              <div></div>
          )}
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between"
          }}
        >
          {props.onShowFeedback == false && currentQuestion.answers !== undefined &&
            FilteredAnswers().map(answer => (

              <Button
                value={answer.value}
                onClick={() => props.onSubmit(answer, currentQuestion)}
              >
                {answer.answerImage == "" || answer.answerImage == undefined  ? (
                  <div style={{ height: "80%", width: "100%" }}>
                    <Textfit mode="multi" max="99" style={{ height: "100%" }}>
                      {answer.value}
                    </Textfit>
                  </div>
                ) : (
                    <ButtonImage src={require("../assets/Measurements/Images/" + answer.answerImage)} ></ButtonImage>
                  )
                }
              </Button>
            ))}

          {props.onShowFeedback == true && currentQuestion.answers !== undefined &&
            FilteredAnswers().map(answer => (

              <Button
                value={answer.value}
                style={{...(answer.correct == true ? {border: "2px solid #19a03f", background: "linear-gradient(0deg,rgba(25, 160, 63, 1) 0%,rgba(43, 196, 86, 1) 100%)"} : {border: "2px solid #ea1d13",background: "linear-gradient(0deg,rgba(234, 29, 19, 1) 0%,rgba(255, 60, 50, 1) 100%)"}) }}
              >
                {answer.answerImage == "" || answer.answerImage == undefined ? (
                  <div style={{ height: "80%", width: "100%" }}>
                    <Textfit mode="multi" max="99" style={{ height: "100%" }}>
                      {answer.value}
                    </Textfit>
                  </div>
                ) : (
                    <ButtonImage src={require("../assets/Measurements/Images/" + answer.answerImage)} ></ButtonImage>
                  )
                }
              </Button>
            ))}
        </div>
        {/*
        <div style={{ display: "flex" }}>
          {currentQuestion.answers !== undefined &&
            currentQuestion.answers.map(answer => (
              <Button>
                <div style={{height:"80%", width:"100%"}}>
                  <Textfit mode="multi" style={{ height: "100%" }}>
                    {answer.value}
                  </Textfit>
                </div>
              </Button>
            ))}
        </div>
          <Button>
            <div style={{height:"80%", width:"100%"}}>
              <Textfit mode="multi" style={{ height: "100%" }}>
                A square
              </Textfit>
            </div>
          </Button>
            */}
      </Container>
    </>
  );
}

const ButtonText = styled.div`
margin: 0 auto;
font-size: 2vw;
padding: 0;
vertical-align: middle;
text-align: center;
display: table-cell;
`

const ButtonImage = styled.img`
height:105%;
//max-width: 80%;
//max-height: 80%;
//padding-top: 15px;
`

//this is green atm
const ColouredImage = styled.img`
  filter: sepia() saturate(10000%) hue-rotate(60deg);
`;

const ScaledImage = styled.img`
  zoom: 2;
  -webkit-transform: scale(2);
  -moz-transform: scale(2);
  -ms-transform: scale(2);
  -o-transform: scale(2);
  transform: scale(2);
`;

const Container = styled.div`
width:80%
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom:100px;
`;

const Question = styled.div`
  background: #FFF;
  user-select: none;
  width: 100%;
  height: 120px;
  line-height: 90px;
  font-size: 4em;
  margin: 15px 25px;
  text-align: center;
  font-weight: 600;
  border: none;
  border-radius: 10px;
`;

const Button = styled.div`
  text-align: center;
  width: 20%;
  height: 150px;
  margin: 5px;
  color: #fff;
  user-select: none;
  background: rgb(234, 146, 19);
  background: linear-gradient(
    0deg,
    rgba(234, 146, 19, 1) 0%,
    rgba(255, 186, 32, 1) 100%
  );
  border: 2px solid #e88f12;
  box-sizing: border-box;
  border-radius: 0.25em;
  cursor: pointer;
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
`;

const DynamicStyle = styled.div`
text-align: center;
position: relative

.centered {
  position: realtive;
  top: 35%;
  //left: -15%;
  //width: 100%
  //text-align: center
  font-size 2em;
  //50%
`;

/*
const Button = styled.div`
  text-align: center;
  width: 10%;
  height: 150px;
  font-size: 4em;
  margin: 5px;
  color: #fff;
  user-select: none;
  background: rgb(234, 146, 19);
  background: linear-gradient(
    0deg,
    rgba(234, 146, 19, 1) 0%,
    rgba(255, 186, 32, 1) 100%
  );
  border: 2px solid #e88f12;
  box-sizing: border-box;
  border-radius: 0.25em;
  cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
    font-size: 2.5em;
  }
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
`;
*/